<section class="section-title">

    <div class="section-title-text">
        <h1 i18n="@@operationLog_title">Registro operazioni</h1>
    </div>

</section>

<section class="operations-content">
    <div fxLayout="row" fxLayoutAlign="start center" class="bordered">
        <div fxFlex="15">
            <p i18n="@@operationLog_show_by" style="margin-left: 15px;">Visualizza per: </p>
        </div>
        <div fxFlex=>
            <mat-radio-group #radioGroup id="filters" fxLayout="row" fxLayoutAlign="start center"
                [formGroup]="filterGroup">

                <mat-radio-button *ngIf="!isService() && !isAdmin()" fxFlex="15"
                    class="mat-radio-button padding-right-10" value="1" (change)="setLogFilter($event)"
                    i18n="@@operationLog_all_filter" [checked]="true">Tutti
                </mat-radio-button>

                <div fxFlex="35">
                    <mat-radio-button class="mat-radio-button padding-right-10" value="2"
                        (change)="setLogFilter($event)" i18n="@@operationLog_operator_filter">Operatore
                    </mat-radio-button>
                    <input id="operatorInput" formControlName="operatorInput" [(ngModel)]="operatorInput"
                        [readonly]="enableOperator" placeholder="{{placeholderString}}">
                </div>

                <div fxFlex="35">
                    <mat-radio-button class="mat-radio-button padding-right-10" value="3"
                        (change)="setLogFilter($event)" i18n="@@operationLog_serial_filter">Seriale
                    </mat-radio-button>
                    <input id="serialInput" formControlName="serialInput" [(ngModel)]="serialInput"
                        [readonly]="enableSerial">
                </div>

            </mat-radio-group>
        </div>
    </div>

    <br clear="all">

    <div>
        <div class="padding-top-25" fxLayout="row" fxLayoutAlign="start center">
            <div id="radiobuttons-div">
                <mat-radio-group id="radiobuttons">
                    <mat-radio-button class="mat-radio-button" value="1" i18n="@@operationLog_today"
                        (change)="setLogTimeRange($event)" [checked]="true">Oggi
                    </mat-radio-button>
                    <mat-radio-button class="mat-radio-button" value="2" (change)="setLogTimeRange($event)"
                        i18n="@@operationLog_yesterday">Ieri
                    </mat-radio-button>
                    <mat-radio-button class="mat-radio-button" style="padding-right: 50px;" value="3"
                        (change)="setLogTimeRange($event)" i18n="@@operationLog_custom">
                        Personalizzato</mat-radio-button>
                </mat-radio-group>
            </div>

            <div id="confirm-button-div" fxFlex="25">
                <a id="confirmButton" class="button" (click)="confirmDateSelection()">
                    <ng-container i18n="@@operationLog_load_data">Carica dati</ng-container> <span>
                        <fa-icon icon="check"></fa-icon>
                    </span>
                </a>
            </div>

            <!-- <div fxFlex="10%">
                spacer
            </div> -->

            <div id="filter-div" fxFlex="4">
                <p i18n="@@operationLog_filter">Filtra: </p>
            </div>

            <div id="table-filter-container" fxFlex="25">
                <div class="table-filter">
                    <input id="filter-input" (keyup)="onKey($event)" />
                </div>
            </div>
        </div>

        <br clear="all">
        <br>
        <div id="datepickers-div" *ngIf="showDatePickers">

            <div id="from-datepicker-div">
                <p class="text-small text-dark" i18n="@@operationLog_start_date">
                    Data di inizio:
                </p>
                <input id="from-datepicker-input" [matDatepicker]="fromDatepicker" [formControl]="fromFormControl">
                <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #fromDatepicker></mat-datepicker>
            </div>
            <div id="to-datepicker-div">
                <p class="text-small text-dark" i18n="@@operationLog_end_date">
                    Data di fine:
                </p>
                <input id="to-datepicker-input" [matDatepicker]="toDatepicker" [formControl]="toFormControl">
                <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #toDatepicker></mat-datepicker>
            </div>
        </div>

        <br clear="all" />

        <div class="control-card-content">

            <mat-paginator (page)="changePage($event)" [pageIndex]="currentPage" [length]="tableItemsTotalCounter"
                [pageSizeOptions]="pageSizeOptions">
            </mat-paginator>


            <div class="table-container" id="device-log-wrapper">

                <table mat-table matSort #logtable class="simple-table">

                    <ng-container matColumnDef="date">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@operationLog_date"
                            style="width: 20%">
                            Data
                        </th>
                        <td mat-cell *matCellDef="let element"> {{ element.dateFriendly }} </td>
                    </ng-container>


                    <ng-container matColumnDef="operator">
                        <th mat-header-cell *matHeaderCellDef i18n="@@operationLog_operator" style="width: 15%">
                            Operatore</th>
                        <td mat-cell *matCellDef="let element" class="date-text">
                            {{ element.operator}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="serial">
                        <th mat-header-cell *matHeaderCellDef i18n="@@operationLog_serial" style="width: 15%">
                            Seriale</th>
                        <td mat-cell *matCellDef="let element" class="date-text">
                            {{ element.serial}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="data">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@operationLog_data"
                            style="width: 35%">
                            Data
                        </th>
                        <td mat-cell *matCellDef="let element"> {{ element.data }} </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="operation">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@operationLog_operation"
                            style="width: 15%">
                            operation
                        </th>
                        <td mat-cell *matCellDef="let element"> {{ element.operation }} </td>
                    </ng-container> -->

                    <ng-container matColumnDef="result">
                        <th mat-header-cell *matHeaderCellDef i18n="@@operationLog_result" style="width: 15%">
                            result</th>
                        <td mat-cell *matCellDef="let element" class="date-text">
                            {{ element.result}}
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                    </tr>

                </table>
            </div>

        </div>
    </div>

    <app-loading-screen #logloader></app-loading-screen>
</section>